import type { SYSAction } from "../../../../../../../_ovlclient/src"
import { Data } from "../../../../../../../_ovlclient/src/dataapi"
import { MergeDeep } from "../../../../../../../_ovlclient/src/global/actions"
import { T } from "../../../../../../../_ovlclient/src/global/globals"
import { SnackAdd } from "../../../../../../../_ovlclient/src/library/snackapi"
import {
  ProcessStart,
  ProcessEnd,
} from "../../../../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"

const FetchInvoices: SYSAction = async (_, { global }) => {
  ProcessStart("GENRefreshData")
  try {
    let state = global.getState()
    let res = await Data("data/getinvoices")
    if (!res.data) {
      return
    }
    if (!state.app.screens.DATInvoice.invoiceDetail) {
      state.app.screens.DATInvoice.invoiceDetail = {
        invoices: res.data.invoices,
      }
    } else {
      MergeDeep(state.app.screens.DATInvoice.invoiceDetail, {
        invoices: res.data.invoices,
      })
    }

    if (!state.app.screens.DATInvoice.dpInvoiceDetail) {
      state.app.screens.DATInvoice.dpInvoiceDetail = {
        dpInvoices: res.data.dpInvoices,
      }
    } else {
      MergeDeep(state.app.screens.DATInvoice.dpInvoiceDetail, {
        dpInvoices: res.data.dpInvoices,
      })
    }
  } finally {
    ProcessEnd("GENRefreshData")
  }
}

const FetchInvoiceDetail: SYSAction<{ key: string; silent?: boolean } | string> =
  async (value, { global }) => {
    ProcessStart("GENRefreshData")
    try {
      let state = global.getState()
      let payload =
        typeof value === "object" ? value : { key: value, silent: false }
      let res = await Data("data/getinvoicedetail", parseInt(payload.key))
      if (!res.data || res.data.attachments.files.length === 0) {
        if (!payload.silent) SnackAdd(T("SYSNoMatchingEntriesFound"), "Warning")
        if (!res.data) return
      }
      MergeDeep(
        state.app.screens.DATInvoice.invoiceDetail.invoices[payload.key],
        res.data
      )
    } finally {
      ProcessEnd("GENRefreshData")
    }
  }

const FetchDPInvoiceDetail: SYSAction<
  { key: string; silent?: boolean } | string
> = async (value, { global }) => {
  ProcessStart("GENRefreshData")
  try {
    let state = global.getState()
    let payload =
      typeof value === "object" ? value : { key: value, silent: false }
    let res = await Data("data/getdpinvoicedetail", parseInt(payload.key))
    if (!res.data || res.data.attachments.files.length === 0) {
      if (!payload.silent) SnackAdd(T("SYSNoMatchingEntriesFound"), "Warning")
      if (!res.data) return
    }
    MergeDeep(
      state.app.screens.DATInvoice.dpInvoiceDetail.dpInvoices[payload.key],
      res.data
    )
  } finally {
    ProcessEnd("GENRefreshData")
  }
}

const HookScreenRefresh: SYSAction = async (_, context) => {
  await FetchInvoices(undefined, context)
}

const HookScreenNavigateIn: SYSAction = async (_, context) => {
  context.global.getState().app.screens.DATInvoice.invoiceOverview.activeFilePopup =
    ""
  await FetchInvoices(undefined, context)
}

let hooks = {
  HookScreenRefresh,
  HookScreenNavigateIn,
}

export let DATInvoice = {
  hooks,
  actions: { FetchInvoiceDetail, FetchDPInvoiceDetail },
}
